<template lang="pug">
.menu-item-wrapper(@click="$emit('click')")
    .mi-img
        slot(name="img")
    .mi-hl {{name}}
    .mi-descr {{description}}
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: ""
        },
        description: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss" scoped>
.menu-item-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-color: white;
    border: solid 1px transparent;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
    border-radius: 8px;
    padding: $sm-space;
    cursor: default;
    &:hover {
        border: solid 1px $primary;
    }

    .mi-img {
        color: $primary;
    }

    .mi-hl {
        font-weight: 700;
        font-size: 1.125rem;
        text-align: center;
    }

    .mi-descr {
        color: $darkgray;
        font-size: 14px;
        text-align: center;
    }
}
</style>